import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuthStore } from "./store/authStore";

const Dashboard = lazy(() => import("./pages/Dashboard"));
const QuizBuilder = lazy(() => import("./pages/QuizBuilder"));
const HostGame = lazy(() => import("./pages/HostGame"));
const GameReport = lazy(() => import("./pages/GameReport"));
const QuizAnalytics = lazy(() => import("./pages/QuizAnalytics"));
const Explore = lazy(() => import("./pages/Explore"));
const CreatorProfile = lazy(() => import("./pages/CreatorProfile"));
const Login = lazy(() => import("./pages/Login"));

function Spinner() {
  return (
    <div className="min-h-screen bg-[#0a0a1a] flex items-center justify-center">
      <div className="w-8 h-8 rounded-full border-2 border-purple-600 border-t-transparent animate-spin" />
    </div>
  );
}

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Suspense fallback={<Spinner />}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/quizzes/new"
          element={
            <ProtectedRoute>
              <QuizBuilder />
            </ProtectedRoute>
          }
        />
        <Route
          path="/quizzes/:id/edit"
          element={
            <ProtectedRoute>
              <QuizBuilder />
            </ProtectedRoute>
          }
        />
        <Route
          path="/games/:pin/host"
          element={
            <ProtectedRoute>
              <HostGame />
            </ProtectedRoute>
          }
        />
        <Route
          path="/games/:pin/report"
          element={
            <ProtectedRoute>
              <GameReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/quizzes/:id/analytics"
          element={
            <ProtectedRoute>
              <QuizAnalytics />
            </ProtectedRoute>
          }
        />
        <Route
          path="/explore"
          element={
            <ProtectedRoute>
              <Explore />
            </ProtectedRoute>
          }
        />
        <Route
          path="/u/:userId"
          element={
            <ProtectedRoute>
              <CreatorProfile />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
